import {
  getAbnLineLabel,
  IAbnProcedureLine,
  IAbnSelectionProcedure,
} from "helpers/abn";
import { centsToDollars, parsePrice } from "helpers/price";

import { getAbnReason } from "../../helpers";
import {
  StyledProceduresListContainer,
  StyledProcedureContainer,
  StyledProcedureItem,
} from "../../styled";

export default function ProceduresList({
  procedures,
  isMedicare,
}: {
  procedures: (IAbnSelectionProcedure & { lines: IAbnProcedureLine[] })[];
  isMedicare: boolean;
}) {
  return (
    <StyledProceduresListContainer>
      <i
        className="pi pi-info-circle text-lg purple"
        style={{ paddingTop: "2px" }}
      />
      <div className="flex flex-column gap-1">
        <p className="text-sm font-semibold dark-gray mb-2">
          The following procedure(s) may not be covered by your insurance and
          could result in additional costs
        </p>
        <StyledProcedureContainer>
          {procedures.map((procedure) => (
            <div key={procedure.cptCode} className="flex flex-column gap-2">
              <StyledProcedureItem>
                <p className="text-sm font-semibold dark-gray">
                  {procedure.cptCode} – {procedure.cptDescription}
                </p>
                {!procedure.lines.length && (
                  <p className="text-sm font-bold dark-gray">
                    {parsePrice(centsToDollars(procedure.amount))}
                  </p>
                )}
              </StyledProcedureItem>
              {procedure.lines.map((line) => (
                <StyledProcedureItem
                  key={`${line.specialty}-${line.providerName}`}
                  className="pl-3"
                >
                  <p className="text-sm font-normal dark-gray">
                    {getAbnLineLabel(line)}
                  </p>
                  <p className="text-sm font-bold dark-gray">
                    {parsePrice(centsToDollars(line.amount))}
                  </p>
                </StyledProcedureItem>
              ))}
            </div>
          ))}
          <p className="text-xs font-normal purple">
            {`Reason: ${getAbnReason(isMedicare)}`}
          </p>
        </StyledProcedureContainer>
      </div>
    </StyledProceduresListContainer>
  );
}
